import Carousel from 'react-slick';
import { APP_IMG, SHOW_COMMEMORATE } from 'src/constants';

const SectionEvents = ({ data }) => {
  const urlImage = `${APP_IMG}/uploads/images/event/`;

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  };

  return (
    <>
      <div className='show-desktop' style={{
        filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.5)' : 'unset'
      }}>
        {
          <Carousel {...settings} >
            {
              Array.isArray(data) && data.filter(data => data.imagePath !== null).map((item, index) => <div key={index} className='banner-special'>
                <img src={`${urlImage}${item.imagePath}`} alt={data.title} />
              </div>)
            }
          </Carousel>
        }
      </div>
      <div className='show-mobile'>
        {
          <Carousel {...settings} >
            {
              Array.isArray(data) && data.filter(data => data.imagePathMobile !== null).map((item, index) => <div key={index} className='banner-special'>
                <img src={`${urlImage}${item.imagePathMobile}`} alt={data.title} />
              </div>)
            }
          </Carousel>
        }
      </div>
    </>
  );
};
export default SectionEvents;
